export const savedScrollPositions: Record<string, number> = {};

export const getResourceFormSavedScrollPositionKey = (
  props:
    | {
        action: "create";
        resource: string;
      }
    | {
        resource: string;
        action: "edit";
        id: string;
      },
) => {
  const { resource } = props;
  return `${
    props.action === "edit" ? "edit" + props.id : "create"
  }-${resource}-form-scroll`;
};
